import { render, staticRenderFns } from "./ContactDetails.vue?vue&type=template&id=0ca7098e&scoped=true&"
import script from "./ContactDetails.vue?vue&type=script&lang=js&"
export * from "./ContactDetails.vue?vue&type=script&lang=js&"
import style0 from "./ContactDetails.vue?vue&type=style&index=0&id=0ca7098e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca7098e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VRow,VTextField})
